module.exports = __webpack_public_path__ + "img/settings-verify-btn.06db534.png";